export const COLOR_SWATCH_DIMENSION_SELECTION = 'COLOR_SWATCH_DIMENSION_SELECTION';
export const CUSTOMER_DROPDOWN_DIMENSION_SELECTION = 'CUSTOMER_DROPDOWN_DIMENSION_SELECTION';
export const OPAL_RECOMMENDATION_DIMENSION_SELECTION = 'OPAL_RECOMMENDATION_DIMENSION_SELECTION';
export const SAVED_SESSION_DIMENSION_SELECTION = 'SAVED_SESSION_DIMENSION_SELECTION';
export const UNKNOWN_PRODUCT_DIMENSION_SELECTION_SOURCE = 'UNKNOWN_PRODUCT_DIMENSION_SELECTION_SOURCE';
